import { getBrandTag } from 'components/Brands';
import { getLogosByTag } from './index';

export const getLogoByBrand = async (brand) => {
  const brandTag = getBrandTag(brand);
  const logos = await getLogosByTag(brandTag);
  return logos[0];
};
